import CONST from '@/constants/achat/expression-besoin';

export default {
  methods: {
    getStatutEB(value) {
      let statut = '';
      switch (value) {
        case CONST.EN_ATTENTE:
          statut = 'En attente de validation';
          break;
        case CONST.VALIDER:
          statut = 'Validé';
          break;
        case CONST.REFUSER:
          statut = 'Refusé';
          break;
        case CONST.DEMANDE_ACHAT:
          statut = "Demande d'achat";
          break;
        case CONST.COLLECTE_PRIX:
          statut = 'Sourcing';
          break;
      }
      return statut;
    },
  },
};
